<template>
  <v-navigation-drawer v-if="isAuthenticated" :model-value="mobile ? !isDrawerMini : true" :rail="!mobile && isDrawerMini" :temporary="mobile" :permanent="!mobile" @update:model-value="syncDrawer">
    <v-list v-model:opened="opened" class="pa-0" density="compact" nav>
      <v-list-item v-if="can('plant.home.read')" to="/" prepend-icon="dashboard" title="Inicio" />
      <v-list-item v-if="can('plant.incomes.read')" to="/entrada" prepend-icon="vertical_align_bottom" title="Entradas" />
      <v-list-item v-if="can('plant.processes.read')" to="/proceso" prepend-icon="transform" title="Procesos" />
      <v-list-item v-if="can('plant.outcomes.read')" to="/salida" prepend-icon="call_made" title="Salidas" />
      <v-list-item v-if="canReadAgrochemicals" to="/agrochemical" prepend-icon="polymer" title="Agroquímicos" />
      <v-list-item v-if="canReadInventory" to="/panol" prepend-icon="inventory_2" title="Pañol" />
      <v-list-group v-if="canReadFieldwork" value="fieldwork">
        <template #activator="{ props }">
          <v-list-item v-bind="props" prepend-icon="agriculture" title="Trabajos de campo" />
        </template>
        <v-list-item v-if="can('fieldwork.records.read')" to="/trabajos-campo" prepend-icon="assignment" title="Registros" />
        <v-list-item v-if="can('fieldwork.machinery.read')" to="/trabajos-campo/maquinarias" prepend-icon="agriculture" title="Maquinarias" />
        <v-list-item v-if="can('fieldwork.reports.read')" to="/trabajos-campo/reportes" prepend-icon="assessment" title="Reportes" />
        <v-list-item v-if="can('fieldwork.prices.read')" to="/trabajos-campo/precios" prepend-icon="local_gas_station" title="Precios de combustible" />
      </v-list-group>
      <v-list-group v-if="canManageSharedCatalogs" value="clients">
        <template #activator="{ props }">
          <v-list-item v-bind="props" prepend-icon="business" title="Clientes y Lugares" />
        </template>
        <v-list-item v-if="can('catalog.companies.read')" to="/compania" prepend-icon="location_city" title="Entidades comerciales" />
        <v-list-item v-if="can('catalog.locations.read')" to="/ubicacion" prepend-icon="person_pin_circle" title="Procedencias y destinos" />
        <v-list-item v-if="can('catalog.lots.read')" to="/lote" prepend-icon="view_column" title="Lotes" />
      </v-list-group>
      <v-list-group v-if="canAny(['security.users.read', 'security.roles.read', 'security.permissions.read', 'security.audit.read'])" value="security">
        <template #activator="{ props }"><v-list-item v-bind="props" prepend-icon="admin_panel_settings" title="Administración" /></template>
        <v-list-item v-if="can('security.users.read')" to="/usuario" prepend-icon="supervisor_account" title="Usuarios" />
        <v-list-item v-if="can('security.roles.read')" to="/administracion/roles" prepend-icon="badge" title="Roles y permisos" />
        <v-list-item v-if="can('security.permissions.read')" to="/administracion/permisos" prepend-icon="key" title="Catálogo de permisos" />
        <v-list-item v-if="can('security.audit.read')" to="/administracion/auditoria" prepend-icon="history" title="Auditoría de accesos" />
      </v-list-group>
    </v-list>
  </v-navigation-drawer>
</template>
<script>
import { mapActions, mapGetters } from 'vuex'
import { useDisplay } from 'vuetify'

export default {
  name: 'SideBar',
  setup () { return { mobile: useDisplay().smAndDown } },
  computed: {
    ...mapGetters(['isDrawerMini']),
    ...mapGetters('authModule', ['isAuthenticated', 'hasPermission', 'hasAnyPermission', 'canReadFieldwork', 'canReadAgrochemicals', 'canReadInventory']),
    canManageSharedCatalogs () {
      return this.hasAnyPermission(['catalog.companies.read', 'catalog.locations.read', 'catalog.lots.read'])
    }
  },
  data () {
    return {
      opened: []
    }
  },
  watch: {
    opened (groups) {
      if (groups.length && !this.mobile && this.isDrawerMini) this.changeDrawerSize()
    },
    '$route.path' () {
      if (this.mobile && !this.isDrawerMini) this.changeDrawerSize()
    }
  },
  methods: {
    can (permission) { return this.hasPermission(permission) },
    canAny (permissions) { return this.hasAnyPermission(permissions) },
    syncDrawer (value) {
      if (this.mobile && value === this.isDrawerMini) this.changeDrawerSize()
    },
    ...mapActions(['changeDrawerSize'])
  }
}
</script>
